import React from "react";
import { Updater } from "use-immer";

import { KnowledgeListFilters } from "@intelligems/ig-types";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { useSelector } from "@src/store";

import { KnowledgeSideNavBarBody } from "./KnowledgeSideNavBarBody";

interface KnowledgeSideNavProps {
  filters: KnowledgeListFilters;
  categories: string[];
  symptoms: string[];
  rootCauses: string[];
  setFilters: Updater<KnowledgeListFilters>;
}

export const KnowledgeSideNav = ({
  filters,
  categories,
  symptoms,
  rootCauses,
  setFilters,
}: KnowledgeSideNavProps) => {
  const sideNavCollapsed = useSelector(
    (state) => state.appSettings.sideNavCollapsed
  );

  return (
    <NavigationDrawer
      isUnauthorized={false}
      hideOrgPicker={true}
      customBody={
        <KnowledgeSideNavBarBody
          drawerOpen={!sideNavCollapsed}
          filters={filters}
          categories={categories}
          symptoms={symptoms}
          rootCauses={rootCauses}
          setFilters={setFilters}
        />
      }
      customFooter={null}
    />
  );
};
